<template>
  <div class="user-avatar">
    <div v-if="user" class="avatar-wrapper">
      <v-avatar left size="26" color="primary" class="avatar-initials">
        <span class="white--text">
          {{ user.sigla }}
        </span>
      </v-avatar>
      <span class="user-name">
        {{ user.name }}
      </span>
    </div>
    <div v-else class="avatar-wrapper avatar-wrapper--empty">
      <div class="avatar-initials avatar-initials--empty">?</div>
      <span class="text-gray-400">---</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EUserAvatar",
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
  },
};
</script>

<style scoped>
.user-avatar {
  display: inline-flex;
  align-items: center;
}

.avatar-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px 6px 6px;
  background: #e5e7eb;
  border-radius: 9999px;
}

.avatar-initials {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.avatar-initials--empty {
  background: #9ca3af;
}

.user-name {
  font-size: 13px;
  color: #374151;
}
</style>
